import { FC } from 'react'

import { Container } from 'components/container'
import { Logos, StyledFooter, Title } from './styled'
import { RFELogo } from './logos/rfe'
import { RiseLogo } from './logos/rise'
import { MoldovaOrg } from './logos/moldova-org'

export const Footer: FC = () => (
  <StyledFooter>
    <Container>
      <div>
        <Title>Despre proiect</Title>
        <p>
          Materialele au fost realizate în cadrul proiectului „Digital Moldova:
          Stories About What Really Matters To Moldovans”, sprijinit financiar
          de ambasada Statelor Unite ale Americii în Republica Moldova, în
          parteneriat cu Moldova.org și RISE Moldova.
        </p>
        <Logos>
          <RFELogo />
          <RiseLogo />
          <MoldovaOrg />
        </Logos>
      </div>
      <div>
        <Title>Despre Europa Liberă Moldova</Title>
        <p>
          Europa Liberă Moldova este o instituție media independentă care oferă
          informații corecte, echilibrate și un jurnalism de calitate. Misiunea
          noastră este să aducem audienței noastre știri, analize și reportaje
          autentice. Ne dedicăm să atingem cele mai înalte standarde ale
          jurnalismului obiectiv, cu determinare și fără a fi influențați de
          presiuni externe. Suntem aici pentru audiența noastră, mereu pregătiți
          să aducem informații importante și relevante.
        </p>
        <p>
          Radio Europa Liberă © 2023 RFE/RL, Inc.
          <br />
          Toate drepturile rezervate
        </p>
      </div>
      <div>
        <Title>Urmărește-ne</Title>
        <ul>
          <li>
            <a href="https://www.facebook.com/europalibera.org" target="_blank">
              Facebook
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/europalibera/" target="_blank">
              Instagram
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@europa-libera-moldova"
              target="_blank"
            >
              Youtube
            </a>
          </li>
        </ul>
      </div>
    </Container>
  </StyledFooter>
)
